module.exports = __webpack_public_path__ + "img/online-reputation-l1.038fa414.svg";